module.exports = __webpack_public_path__ + "static/media/info.67759de5.svg";